export enum AnalyticsCategory {
  ORDER_CREATION = 'Order Creation',
  ORDER_EDITION = 'Order Edition',
  VIEWPORT = 'Viewport',
  VEHICLE_MANAGEMENT = 'Vehicle Management',
}
